import { call, put, take, takeLatest, all } from 'redux-saga/effects';
import App from 'modules/App';
import Account from 'modules/Account';
import Information from 'modules/Information';
import Setup from 'modules/Setup';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import messages from './messages';
function* patientSetup({ payload }) {
    try {
        const { createPatientProfile, updateInformations, updateAccountSettings } = payload;
        const { createPatientValues, authorizationCode, standards, enrollCode, invitationCode } = createPatientProfile;
        const calls = [
            put(Information.actions.updateInformation(updateInformations)),
            put(Setup.actions.createPatientProfile(createPatientValues, authorizationCode, standards, enrollCode, invitationCode))
        ];
        const takes = [
            take([
                Information.actionTypes.UPDATE_INFORMATION_SUCCESS,
                Information.actionTypes.UPDATE_INFORMATION_ERROR
            ]),
            take([
                Account.actionTypes.CREATE_PATIENT_PROFILE_SUCCESS,
                Account.actionTypes.CREATE_PATIENT_PROFILE_ERROR
            ])
        ];
        if (updateAccountSettings) {
            calls.push(put(Account.actions.updateAccountSettings(updateAccountSettings)));
            takes.push(take([
                Account.actionTypes.UPDATE_ACCOUNT_SETTINGS_SUCCESS,
                Account.actionTypes.UPDATE_ACCOUNT_SETTINGS_ERROR
            ]));
        }
        yield all(calls);
        const [updateInformationResult, createPatientProfileResult, updateAccountSettingsResult] = yield all(takes);
        if (updateInformationResult.type === Information.actionTypes.UPDATE_INFORMATION_ERROR) {
            yield put(actions.patientSetupError(updateInformationResult.error));
            return;
        }
        if (createPatientProfileResult.type === Account.actionTypes.CREATE_PATIENT_PROFILE_ERROR) {
            yield put(actions.patientSetupError(createPatientProfileResult.error));
            return;
        }
        if (updateAccountSettingsResult && updateAccountSettingsResult.type === Account.actionTypes.UPDATE_ACCOUNT_SETTINGS_ERROR) {
            yield put(actions.patientSetupError(updateAccountSettingsResult.error));
            return;
        }
        yield put(actions.patientSetupSuccess());
    } catch (err) {
        yield put(actions.patientSetupError(err));
        yield call(App.dispatchError, err, messages);
    }
}
function* sagas() {
    yield takeLatest(actionTypes.PATIENT_SETUP, patientSetup);
}
export default [
    sagas
];
